/**
 * Canonical IoT-device vendor identifiers.
 *
 * These values are PERSISTED by the backend — they are written to
 * `client_iot_devices.vendor` and returned in the client profile payload's
 * `iotVendors` — so they must match `lib/iotVendorRegistry.js` in cortex-be
 * exactly and must never change without a data migration on that side.
 *
 * This module exists because the strings were previously inlined at every call
 * site, which makes a typo silently mean "this client has no such sensor"
 * rather than raising anything.
 *
 * NOT in scope: adjacent namespaces that happen to share a string but are not
 * IoT-device vendors — e.g. a health-data `source` of "apple_watch". Those carry
 * their own column semantics and keep their own values.
 */
export const IOT_VENDORS = Object.freeze({
  PONTOSENSE: "pontosense",
  APPLE_WATCH: "apple_watch",
  BOUNDARYCARE: "boundarycare",
  HYDROSTASIS: "hydrostasis",
  XANDAR_KARDIAN: "xandar_kardian",
});
